import GetMiniBasketRequestModelBase from '../_generated/modelBases/get-mini-basket-request-model-base';

export default class GetMiniBasketRequestModel extends GetMiniBasketRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
